import React from 'react';

import { QUICKBOOKS_BASE_URL } from '../../../api';
import { TYPE_TITLE } from '../../../const/treatment';
import { mapDefaultRemoteOptions, mapPayeeOptions } from '../../../Helper';
import { RemoteOptionsResponse } from '../../../types';
import { FormTypeOption, FormTypeOptionComponentProps } from '../../../types/treatment';
import Form from '../Form/Form';

const SAVE_TREATMENT_ENDPOINT = `${QUICKBOOKS_BASE_URL}/:documentId/createCheck`;

const mapRemoteOptions = (responseData: RemoteOptionsResponse) => {
  const payees = mapPayeeOptions(responseData.vendors, responseData.employees);
  const defaultRemoteOptions = mapDefaultRemoteOptions(responseData);

  return {
    ...defaultRemoteOptions,
    payees,
  };
};

export const DISABLED_FIELDS = {
  isMethodDisabled: true,
  isAccountDisabled: false,
  isTermsDisabled: true,
  isDueOnDisabled: true,
};

const REQUIRED_FIELDS = {
  isMethodRequired: false,
  isAccountRequired: true,
  isTermsRequired: false,
  isDueOnRequired: false,
};

const CheckPaymentForm = ({ register, control, dropdowns }: FormTypeOptionComponentProps) => {
  return (
    <Form
      register={register}
      control={control}
      dropdowns={dropdowns}
      disabledFields={DISABLED_FIELDS}
      requiredFields={REQUIRED_FIELDS}
      useBankAccount={true}
    />
  );
};

export default CheckPaymentForm;
export const title = TYPE_TITLE['Check'];
const optionName = TYPE_TITLE['Check'];
const id = 'Check';

export const CheckPaymentFormOption: FormTypeOption = {
  id,
  title,
  optionName,
  Component: CheckPaymentForm,
  mapRemoteOptions,
  saveTreatmentEndpoint: SAVE_TREATMENT_ENDPOINT,
  customSuccessModal: true,
  disabledFields: DISABLED_FIELDS,
  requiredFields: REQUIRED_FIELDS,
};
